// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-908b2534] .type-description{font-size:11px}label.radio[data-v-908b2534]{font-size:16px}.custom-permissions[data-v-908b2534]{display:grid;grid-template-columns:1fr 1fr 1fr}.custom-permissions.two-column[data-v-908b2534]{grid-template-columns:1fr 1fr}.custom-permissions[data-v-908b2534] .checkbox-label{margin-right:0}", ""]);
// Exports
module.exports = exports;
